import { render, staticRenderFns } from "./Apresentacoes.vue?vue&type=template&id=42ec1cea&scoped=true&"
import script from "./Apresentacoes.vue?vue&type=script&lang=js&"
export * from "./Apresentacoes.vue?vue&type=script&lang=js&"
import style0 from "./Apresentacoes.vue?vue&type=style&index=0&id=42ec1cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec1cea",
  null
  
)

export default component.exports